/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_ListInputs */

const cs_view_list = /** @type {(inputs: View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam`)
};

const en_view_list = /** @type {(inputs: View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

/**
* | output |
* | --- |
* | "List" |
*
* @param {View_ListInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const view_list = /** @type {((inputs?: View_ListInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_ListInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_list(inputs)
	return cs_view_list(inputs)
});